import {
  REORDER_INITIATIVE_QUEUE_ITEMS
} from "../constants/action-types"

const orderedIdsFromItems = (itemHash) => {
  const items = Object.values(itemHash).sort((a, b) => {
    if (a.initiative === b.initiative) {
      return a.initiative_priority - b.initiative_priority;
    }
    return b.initiative - a.initiative;
  });
  const itemIds = items.map((item) => {
    return `${item.id}`;
  });
  return itemIds;
};

const initalState = {
  items: INITIAL.initiativeQueueItems,
  orderedItemIds: orderedIdsFromItems(INITIAL.initiativeQueueItems)
}

export default (state = initalState, action) => {
  switch(action.type) {
    case REORDER_INITIATIVE_QUEUE_ITEMS:
      // Create a new items object that preserves the hidden state
      const updatedItems = {};
      Object.keys(action.payload).forEach(id => {
        updatedItems[id] = {
          ...action.payload[id],
          hidden: action.payload[id].hidden !== undefined ? action.payload[id].hidden : (state.items[id] ? state.items[id].hidden : false)
        };
      });

      return {
        ...state,
        items: updatedItems,
        orderedItemIds: orderedIdsFromItems(updatedItems)
      }
    case 'SET_INITIATIVE_ORDER':
      return {
        ...state,
        orderedItemIds: action.payload.orderedItemIds,
        items: action.payload.items
      }
    default:
      return state
  }
}
